<template>
    <div>
        <template v-if="!sectores && !$cookies.isKey('sectores')">
            <div class="row" >
                <card-online v-for="card in cardsOnline" :bestTpv="card.idBusiness == mostSuccessfulTpv" :card="card" :key="card.idBusiness">
                </card-online>
            </div>
            <div class="row" v-if="cardsOnline.length > 0">
                <div class="col-md-12 totalCards">
                    <h2>{{$t("total")}}: {{totalCards | currency}}</h2>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="mb-4">
                <div class="form-group">
                    <label for="filtro">Filtrar</label>
                    <br>
                    <el-select
                        class="select-default"
                        size="large"
                        v-model="idFiltro"
                        filterable
                        @change="cambiarFiltro()"
                        :placeholder="'Selecciona un sector'"
                        >
                        <el-option
                            v-for="sector in listaSectoresFiltro"
                            class="select-primary"
                            :value="sector.id"
                            :label="sector.nombre"
                            :key="sector.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="row mb-4" v-if="cardsOnline.length > 0 && idFiltro == -1">
                <div class="col-md-12 totalCards">
                    <h2 class="mt-2">TOTAL: {{totalCards | currency}}</h2>
                </div>
            </div>
            <div class="row" v-for="sector in listaSectoresOrganizados" :key="sector.id">
                <template v-if="idFiltro == -1 || idFiltro != -1 && idFiltro == sector.id">
                    <div class="col-12">
                            
                        <h4 style='font-family: "Numier", "Helvetica Neue", Arial; font-weight: bold; color: #1E22AA; font-size: 25px;'>{{sector.nombre}}</h4>
                        <br>
                        <div class="col-md-12 totalCards" v-if="sector.cards.length > 0"><div><h4>Total {{sector.nombre.split(">").pop()}}: {{sector.totalCards | currency}}</h4></div></div>
                        <div class="row mt-3">
                            <card-online v-for="card in sector.cards" :card="card" :key="card.idBusiness">
                                {{card}}
                            </card-online>
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
    let p1, p2 = null;
    import CardOnline from './CardOnline.vue';
    import {Loading, Select, Option} from 'element-ui';
    import swal from 'sweetalert2'
    import { mapState, mapMutations } from 'vuex';

    export default {
        components: {
            CardOnline,
            [Select.name]: Select,
            [Option.name]: Option,
        },

        created() {
            this.loading = Loading.service({text: this.$t('cargando')});
            this.$store.dispatch("setNameRoute", "Cajas Online");
            
            
            if (!this.sectores && !this.$cookies.isKey("sectores")) {
                //Comportamiento normal
                
                this.getOnline();
            } else {
                
                //Si tiene sectores
                //Y tiene más de un sector en la lista, significa que ya han cargado
                if (this.listaSectores.length > 1) {
                    //Se llama al nuevo online
                    this.getOnlineSectores();
                } else {
                    //Si no los tiene, se consiguen
                    this.getSectores();
                }
            }
            //this.getCamaras();
            //this.restrictions();
        },
        data() {
            return {
                //premiumProfile:false,
                cardsOnline: [],
                mostSuccessfulTpv : -1,
                loading: null,
                cams: [],
                indexCamara: 0,

                camaras:true,
                listaSectoresOrganizados: [],
                idFiltro: this.$cookies.isKey('filtroSector') ? parseInt(this.$cookies.get('filtroSector')) : -1,
                listaSectoresFiltro: [],
            }
        },
        methods: {

            ...mapMutations(['changeListaSectores']),
            cambiarFiltro() {
                this.$cookies.set("filtroSector", this.idFiltro, '1d');
            },
            calcularTotal(cards) {
                let total = 0;

                cards.forEach(card => {
                    total += card.value;
                })

                return total;
            },
            getOnline() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                p1 = this.axios.get(this.$store.getters.apiUrl + "online/getOnline", config)
                    .then(function (response) {
                        if (response.data.response) {

    
                            if (response.data.result.length == 1) {

                                if (response.data.result[0].caducada == 0 && response.data.result[0].totalTpvOnline > 0) {
                                    
                                    vm.$router.push({
                                        name: 'online-detail',
                                        params: {idBusiness: response.data.result[0].idBusiness}
                                    })
                                } else {
                                    vm.$router.push({name: 'informes'});
                                }

                            } else if (response.data.result.length == 0) {
                                vm.$router.push({name: 'informes'});
                            } else {
  
                                vm.cardsOnline = response.data.result.slice();
                                vm.getBestTpv(response.data.result)
                               
                                
                            }

                            vm.loading.close();
                        }
                        else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            
                            vm.loading.close();
                        }
                    })
                    .catch(function (error) {
                        vm.$router.push("serverdown");
                        vm.loading.close();
                    });
            },
            getBestTpv(listTpvs){

                let sortedList = listTpvs.sort((a,b)=> b.value - a.value);

                //this.cardsOnline = originalList;

                this.mostSuccessfulTpv = sortedList[0].idBusiness;

            },

            isPremium() {
                // console.log(this.$store.state.xuser.isPremium == "1");
                return this.$store.state.premiumProfile
            },

            getOnlineSectores() {

                //Preparamos una lista con los sectores que nos vamos a traer junto con sus business
                this.listaSectoresOrganizados = [];

                //Empezamos a pushear cada sector que vamos a utilizar al nuevo array
                //this.listaSectoresOrganizados.push({ id: sector.id, nombre: sector.name.replaceAll("->", `▶`), businesses: [], cards: []});

                //Conseguiremos los negocios de cada sector
                let controller = "getBusinessesBySectors";

                var config = {
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                    params: {
                    jwt: this.$store.getters.jwt,
                    }
                };

                var params = {
                    idBusiness: this.listaSectores[0].idBusinessMaster/*sector.idBusinessMaster*/,
                    sectores: this.listaSectores.filter((sector) => {return sector.id != 0}),
                    /*idSector: sector.id,
                    //no hace falta product
                    product: null,*/
                    //
                    jwt: this.$store.getters.jwt,
                };

                this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
                let vm = this;

                p2 = this.axios
                    .post(
                        this.$store.getters.apiUrl + "general/" + controller,
                        params,
                        config
                    )
                    .then(function(response) {
                        if (response.data.response) {

                            //Recogemos l
                            response.data.result.forEach(result => {
                                result.nombre = result.nombre.replaceAll("->", `>`);
                            })

                            vm.listaSectoresOrganizados = response.data.result;
                            
                            //Asignamos al sector que estamos recorriendo, los negocios
                            //vm.listaSectoresOrganizados.push({ id: sector.id, nombre: sector.name.replaceAll("->", `▶`), businesses: businesses, cards: []});
                            /*vm.listaSectoresOrganizados.forEach(sectorOrganizado => {

                                if (sectorOrganizado.id == sector.id) {
                                    sectorOrganizado.businesses = businesses;
                                }
                            });*/

                        }
                    }).catch(function(error) {
                        console.log(error);
                    });
                //})

                //Conseguimos los botones o tarjetas
                this.getOnline();
                //Cuando los tengamos
                Promise.all([p1, p2]).then(() => {
                    
                    let tiene_negocios_sin_sector = this.listaSectores.find(sector => sector.id == 0);

                    //Comprobamos si va a tener el sin sectores
                    if (!tiene_negocios_sin_sector) {
                        //Preparamos el todos para el filtro
                        this.listaSectoresFiltro.push({id: -1, nombre: "Todos los sectores"});

                        //Recorremos la lista de sectores para asignar las tarjetas y el total de las mismas
                        this.listaSectoresOrganizados.forEach(sectorOrganizado => {

                            this.cardsOnline.forEach(card => {
                                if (sectorOrganizado.businesses.includes(parseInt(card.idBusiness))) {  
                                    sectorOrganizado.cards.push(card);
                                }  
                            })

                            sectorOrganizado.totalCards = this.calcularTotal(sectorOrganizado.cards);

                            //Añadimos los datos del sector a la lista del filtro
                            this.listaSectoresFiltro.push({id: sectorOrganizado.id, nombre: sectorOrganizado.nombre.replaceAll('>', '->')});
                        })
                        
                    } else {
                        //Por cada sector vamos asignando las tarjetas
                        this.listaSectoresOrganizados.forEach(sectorOrganizado => {

                            this.cardsOnline.forEach(card => {
                                if (sectorOrganizado.businesses.includes(parseInt(card.idBusiness))) {   
                                    sectorOrganizado.cards.push(card);
                                }
                            })

                            //sectorOrganizado["totalCards"] = this.calcularTotal(sectorOrganizado["cards"]);
                        })

                        //Una vez asignadas las tarjetas, preparamos el negocio sin sector, encontrándolo en la lista de sectores
                        let negocios_sin_sector = this.listaSectores.find(sector => sector.id == 0).negocios;
                        let cards_sin_sector = [];

                        //Recorremos sus negocios para poder asignar las cards correspondientes
                        negocios_sin_sector.forEach(negocio => {
                            this.cardsOnline.forEach(card => {
                                if (parseInt(card.idBusiness) == parseInt(negocio.id)) {
                                    cards_sin_sector.push(card);
                                }
                            })
                        })
                        
                        //Pusheamos al array que utilizaremos "Sin sectores"
                        this.listaSectoresOrganizados.push({ id: 0, nombre: "Sin sectores", businesses: negocios_sin_sector, cards: cards_sin_sector})
                        
                        //Y ahora preparamos la lista que vamos a utilizar para poder filtrar los sectores
                        this.listaSectoresFiltro.push({id: -1, nombre: "Todos los sectores"});

                        //Recorremos de nuevo la lista de sectores que tenemos para calcular el total de cada sector y para añadirlos al array del filtro
                        this.listaSectoresOrganizados.forEach(sector => {
                            sector.totalCards = this.calcularTotal(sector.cards);
                            this.listaSectoresFiltro.push({id: sector.id, nombre: sector.nombre.replaceAll('▶', '->')});
                        })
                    }
                });
            },
            /*restrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByUser", config)
                    .then(function (response) {

                        if (response.data.response) {

                            for (let i = 0; i < response.data.result.length; i++) {

                                switch (response.data.result[i].idRestriction) {

                                    case 52:
                                        vm.camaras = false;
                                        break;

                                }
                            }


                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },*/

            getCamaras() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getCamaras", config)
                    .then(function (response) {

                        if (response.data.response) {
                            vm.cams = response.data.result;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        vm.$router.push("serverdown");
                        vm.loading.close();
                    });
            },

            openModal(index) {
                this.indexCamara = index;
                this.$modal.show("modal-cam");
            },

            closeModal() {
                this.$modal.hide("modal-cam");
            },

            getSectores() {
                let config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
                    .then(function (response) {

                    if (response.data.response) {
                        response.data.result["sectores"].forEach((sector) => {
                            sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                            sector.id = parseInt(sector.id);
                        });
                        vm.changeListaSectores(response.data.result["sectores"]);
                
                        //vm.loading.close();
                        
                        //Métodos locales
                        vm.getOnlineSectores();
                    }

                }).catch(function (error) {
                    console.log(error);
                })
            }
        },
        computed: {
            ...mapState(["listaSectores", "sectores"]),

            totalCards() {
                var total = 0;

                for (var i = 0; i < this.cardsOnline.length; i++) {
                    if (this.cardsOnline[i].caducada != 1) {
                        total += this.cardsOnline[i].value;
                    }
                }
                return total;
            },
        }
    }
</script>
<style scoped>
    .totalCards {
        text-align: center;
    }

    h4 {
        margin: 0px;
    }

    .totalCards h2 {
        padding: 15px;
        background-color: #CCC;
        color: #111;
        text-shadow: 1px 1px #ddd;
        border-radius: 4px;
    }
    
    .totalCards div {
        margin-bottom: 3%;
        padding: 15px;
        background-color: #CCC;
        color: #111;
        text-shadow: 1px 1px #ddd;
        border-radius: 4px;
    }
    .card {
        padding: 5px;
    }

    .select-default {
        width: 20%;
    }

    label {
        font-size: 14px;
        margin-bottom: 5px;
        color: #333333;
        font-weight: 400;
    }

@media only screen and (max-width: 768px) {

    .select-default {
        margin-top: 5%;
        width: 100%;
    }

    .totalCards div {
        margin-bottom: 10%;
        padding: 15px;
        background-color: #CCC;
        color: #111;
        text-shadow: 1px 1px #ddd;
        border-radius: 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Online.vue